var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86865 4.19995L6.23434 1.56564C5.92192 1.25322 5.92192 0.746685 6.23434 0.434266C6.54676 0.121846 7.05329 0.121846 7.36571 0.434266L11.3657 4.43427C11.6781 4.74669 11.6781 5.25322 11.3657 5.56564L7.36571 9.56564C7.05329 9.87806 6.54676 9.87806 6.23434 9.56564C5.92192 9.25322 5.92192 8.74669 6.23434 8.43427L8.86865 5.79995H1.20002C0.758197 5.79995 0.400024 5.44178 0.400024 4.99995C0.400024 4.55812 0.758197 4.19995 1.20002 4.19995H8.86865Z",
    fill: "#0B24FB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_55",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86865 4.19995L6.23434 1.56564C5.92192 1.25322 5.92192 0.746685 6.23434 0.434266C6.54676 0.121846 7.05329 0.121846 7.36571 0.434266L11.3657 4.43427C11.6781 4.74669 11.6781 5.25322 11.3657 5.56564L7.36571 9.56564C7.05329 9.87806 6.54676 9.87806 6.23434 9.56564C5.92192 9.25322 5.92192 8.74669 6.23434 8.43427L8.86865 5.79995H1.20002C0.758197 5.79995 0.400024 5.44178 0.400024 4.99995C0.400024 4.55812 0.758197 4.19995 1.20002 4.19995H8.86865Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_55)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNext);
export default __webpack_public_path__ + "static/media/icon-next.dd5ff87730866ea57f63a892ecb23dbf.svg";
export { ForwardRef as ReactComponent };